<template>
    <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-产品-添加
    -->
    <div>
        <el-dialog title="变更记录" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
            :close-on-press-escape="false" width="50%" v-loading="loading">
            <div class="product-add pb50">
                <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
                    <el-table-column prop="type" label="变更类型">
                        <template slot-scope="scope">
                            <div v-text="scope.row.type == 1?'添加'  :  scope.row.type == 2?'修改'  : scope.row.type == 3?'删除'  : scope.row.type == 4?'审核'  : scope.row.type == 5?'上架'  : '下架'"></div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="content" label="变更内容"></el-table-column>
                    <el-table-column prop="update_time" label="变更时间"></el-table-column>
                    <el-table-column prop="user_name" label="操作人"></el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
                    :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
                    :total="totalDataNumber"></el-pagination>
            </div>
        </el-dialog>
       
    </div>
</template>

<script>
    import HproductApi from '@/api/hproduct.js';

    import Upload from '@/components/file/Upload';
    import Categoryas from "@/components/categorya/index.vue";
    import draggable from "vuedraggable";
    import Uediter from '@/components/UE.vue';
    import {
        error
    } from 'shelljs';
    export default {
        components: {
        
            /*图片上传*/
            Upload: Upload,
            Categoryas,
            draggable,
            Uediter
        },
        created() {

        },
        data() {
            return {
                tableData: [],
                loading: false,
                /*验证规则*/
                rules: {
                    name: [{
                        required: true,
                        message: '请输入产品名称',
                        trigger: 'blur'
                    }],
                },
                dialogVisible: false,
                iscategorya: false,
                excludeIds: [],
                isProductUpload: false,
                code: "album",
                type: [],
                catgory: [],
                curPage:1,
                pageSize:30,
                totalDataNumber:0,
                parameterList: [] //参数列表
            };
        },
        created() {
            this.dialogVisible = this.open_add;
            console.log(this.open_add)
            console.log(this.rid)
            this.getRecord()
            // this.getSetting();
            // this.getData()
        },
        props: ["open_add", "rid"],
        methods: {
            getRecord() {
                let that = this
                let datas = {}
                datas.hproduct_id = that.rid
                datas.page = that.curPage
                datas.list_rows = that.pageSize
                HproductApi.getLog(datas, true)
                    .then(res => {
                        if(res.code == 1){
                            that.curPage = res.data.current_page
                            that.totalDataNumber = res.data.total
                            that.tableData = res.data.data
                        }
                        
                    })
                    .catch(error => {});
            },

            /*选择第几页*/
            handleCurrentChange(val) {
                this.curPage = val;
                this.getTableList();
            },

            /*每页多少条*/
            handleSizeChange(val) {
                this.curPage = 1;
                this.pageSize = val;
                this.getTableList();
            },

            /*关闭弹窗*/
            dialogFormVisible(result) {
                this.$emit("close", {
                    openDialog: false,
                    "type": ""
                });
            },
        }
    };
</script>

<style>
    .edit_container {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    .ql-editor {
        height: 400px;
    }


    .draggable-list {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
    }

    .draggable-list .wrapper>span {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }

    .draggable-list .item {
        position: relative;
        width: 110px;
        height: 110px;
        margin-top: 10px;
        margin-right: 10px;
        border-radius: 8px;
        overflow: hidden;
        border: 1px solid #dddddd;
    }

    .draggable-list .delete-btn {
        position: absolute;
        top: 0;
        right: 0;
        width: 16px;
        height: 16px;
        background: red;
        line-height: 16px;
        font-size: 16px;
        color: #ffffff;
        display: none;
    }

    .draggable-list .item:hover .delete-btn {
        display: block;
    }

    .draggable-list .item img {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        max-height: 100%;
        max-width: 100%;
    }

    .draggable-list .img-select {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px dashed #dddddd;
        font-size: 30px;
    }

    .draggable-list .img-select i {
        color: #409eff;
    }
</style>


// WEBPACK FOOTER //
// src/views/plus/hproduct/index/part/record.vue